import { takeLatest, all, put, fork, call } from 'redux-saga/effects'
import { push } from 'connected-react-router'

import * as actions from '../../actions/actions'

import { postCampaign } from '../../../api/campaignApi'
import {getCorporateAuthorizationUserType} from "../../../api/userApi";

export default function* campaignCreateSaga() {
  yield all([
    fork(watchSaveCampaignCreateRequest),
    fork(watchCreateCampaignEnabledRequest),
    fork(watchCreateCampaignCampaignNameRequest),
    fork(watchCreateCampaignCampaignLogoRequest),
    fork(watchCreateCampaignCorporateRequest),
    fork(watchCreateCampaignAuthorizersRequest),
    fork(watchCreateCampaignCleanRequest),
    fork(watchCheckCorporateAuthTypeRequest)
  ]);
}

function* watchSaveCampaignCreateRequest() {
  yield takeLatest(
    actions.SAVE_CAMPAIGN_CREATE_REQUEST,
    saveCampaignCreateRequest
  )
}

function* saveCampaignCreateRequest(campaignData){
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(postCampaign, campaignData.value.bankId,campaignData.value.campaign)
    yield put({ type: actions.SAVE_CAMPAIGN_CREATE_SUCCESS, value: data })
    yield put(push(`/campaign`))
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
    yield put({ type: actions.CREATE_CAMPAIGN_CLEAN_REQUEST })
  } catch (error) {
   if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.SAVE_CAMPAIGN_CREATE_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchCheckCorporateAuthTypeRequest() {
  yield takeLatest(

      actions.CREATE_CAMPAIGN_AUTH_TYPE_CHECK_REQUEST,
      checkCorporateAuthTypeRequest
  )
}

function* checkCorporateAuthTypeRequest(corporateData){
  yield put({type: actions.CLEAN_ERROR})
  yield put({ type: actions.PROGRESS_START_REQUEST })
  try {
    let { data } = yield call(getCorporateAuthorizationUserType, corporateData.value.bankId,corporateData.value.corporate)
    yield put({ type: actions.CREATE_CAMPAIGN_AUTH_TYPE_CHECK_SUCCESS, value: data })
    yield put({ type: actions.PROGRESS_STOP_REQUEST })
  } catch (error) {
    if(error.response){
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.CREATE_CAMPAIGN_AUTH_TYPE_CHECK_FAILURE, error: error.response })
      yield put({ type: actions.FETCH_ERROR_REQUEST_SERVER, error: error.response })
    }else if(error.request)
    {
      yield put({ type: actions.PROGRESS_STOP_REQUEST })
      yield put({ type: actions.FETCH_ERROR_REQUEST_CLIENT, error: error.response })
    }
  }
}

function* watchCreateCampaignEnabledRequest() {
  yield takeLatest(
    actions.CREATE_CAMPAIGN_ENABLED_FILED_CHANGE_REQUEST,
    createCampaignEnabledRequest
  )
}

function* createCampaignEnabledRequest(enabled) {
  yield put({ type: actions.CREATE_CAMPAIGN_ENABLED_FILED_CHANGE, value: enabled.value })
}

function* watchCreateCampaignCampaignNameRequest() {
  yield takeLatest(
    actions.CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE_REQUEST,
    createCampaignCampaignNameRequest
  )
}

function* createCampaignCampaignNameRequest(campaignName) {
  yield put({ type: actions.CREATE_CAMPAIGN_CAMPAIGN_NAME_FILED_CHANGE, value: campaignName.value })
}

function* watchCreateCampaignCampaignLogoRequest() {
  yield takeLatest(
    actions.CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE_REQUEST,
    createCampaignCampaignLogoRequest
  )
}

function* createCampaignCampaignLogoRequest(campaignLogo) {
  yield put({ type: actions.CREATE_CAMPAIGN_CAMPAIGN_LOGO_FILED_CHANGE, value: campaignLogo.value })
}

function* watchCreateCampaignCorporateRequest() {
  yield takeLatest(
    actions.CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE_REQUEST,
    createCampaignCorporateRequest
  )
}

function* createCampaignCorporateRequest(corporate) {
  yield put({ type: actions.CREATE_CAMPAIGN_CORPORATE_FILED_CHANGE, value: corporate.value })
}


function* watchCreateCampaignAuthorizersRequest() {
  yield takeLatest(
      actions.CREATE_CAMPAIGN_AUTHORIZERS_CHANGE_REQUEST,
      createCampaignAuthorizersRequest
  )
}

function* createCampaignAuthorizersRequest(authorizer) {
  yield put({ type: actions.CREATE_CAMPAIGN_AUTHORIZERS_CHANGE, value: authorizer.value })
}

function* watchCreateCampaignCleanRequest() {
  yield takeLatest(
    actions.CREATE_CAMPAIGN_CLEAN_REQUEST,
    createCampaignCleanRequest
  )
}

function* createCampaignCleanRequest() {
  yield put({ type: actions.CREATE_CAMPAIGN_CLEAN })
}